import { useQuery } from '@apollo/client/react'
import {
  OrgTicketStatesDocument,
  OrgTicketSystemsDocument,
  type OrgTicketSystemsQuery,
} from '@/graphql/generated/graphql'

export type OrgTicketSystem =
  OrgTicketSystemsQuery['orgTicketSystems']['items'][number]

/** Catálogo del form de crear: sistemas + campos obligatorios + tipos creables. */
export function useOrgTicketSystems() {
  const { data, loading, error } = useQuery(OrgTicketSystemsDocument, {
    fetchPolicy: 'cache-first',
  })
  return {
    systems: data?.orgTicketSystems.items ?? [],
    creatableTypes: data?.orgTicketSystems.creatableTypes ?? [],
    loading,
    error,
  }
}

/** Catálogo de estados (opciones del filtro del listado). */
export function useOrgTicketStates() {
  const { data, loading, error } = useQuery(OrgTicketStatesDocument, {
    fetchPolicy: 'cache-first',
  })
  return { states: data?.orgTicketStates ?? [], loading, error }
}
